import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components



const Banner = () => {
  return (
    <section className="banner">
      <div className="content">

        {/* Heading component with dynamic props */}
        <Heading title={'Connect, Learn, and Visit Maker Faire 2025 in Taipei.'} subTitle={'Special thanks MFT Teams to support WRG, extra event bundle!'} linear sideHeading />

        <Button link={'Registration'} title={'Register Now'} />

      </div>
    </section>
  );
};

export default Banner;